export * from './src/simple.html.renderer'